import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const createPopupEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-navigation-create-popup" */ './create-popup-content.tsx'),
	),
	getPreloadProps: () => ({
		queries: {},
	}),
});
